import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import TablePagination from '@material-ui/core/TablePagination'
import Paper from '@material-ui/core/Paper'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTrash,
  faUserEdit,
  faEllipsisV,
  faChevronRight,
  faChevronDown,
  faDownload
} from '@fortawesome/free-solid-svg-icons'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import * as API from '../../actions/api'
// import * as XLSX from 'xlsx';

import { TableHead, TableTitle } from '../../common'
import Dropzone from 'react-dropzone'

import * as Strings from './strings'
import * as Functions from '../../../helpers/Functions'
import * as configActions from '../../actions/Config'
import * as Constants from '../../../helpers/Constants'
import * as userActions from '../../actions/Users'
import * as apartmentsActions from '../../actions/Apartments'

const APARTMENT_ROWS = [
  {
    id: 'address',
    label: 'Adress',
    numeric: false,
    sortType: 'string'
  },
  {
    id: 'number',
    label: Strings.default.APARTMENT_NUMBER,
    numeric: false,
    sortType: 'string'
  },
  {
    id: 'code',
    label: Strings.default.CODE,
    numeric: false,
    sortType: 'string'
  }
]

class UserTable extends Component {
  state = {
    page: 0,
    rowsPerPage: 10,
    orderBy: 'number',
    order: 'asc',
    sortType: 'integer',
    menuExpanded: null,
    showRows: [],
    downloadingBulkPdf: false
  }

  render() {
    const { classes, data, user } = this.props
    const {
      page,
      rowsPerPage,
      orderBy,
      order,
      sortType,
      menuExpanded,
      anchorEl,
      showRows
    } = this.state
    const startIndex = page * rowsPerPage
    const apartments = data.community.apartments
    const comunityName = data.community.name

    return (
      <div>
        {true ? null : (
          <Dropzone
            onDrop={files => {
              const reader = new FileReader()
              console.log(files)
              reader.readAsText(files[0])

              reader.onload = e => {
                const csv = e.target.result
                console.log(csv)
                /*let lines = csv.split(/\r\n|\n/)
              console.log(lines)*/
              }
            }}
            onFileDialogCancel={() => {}}
            multiple={false}
            style={{
              width: '100%',
              height: 100,
              border: '1 solid rgba(224, 224, 224, 1)',
              display: 'flex',
              borderRadius: 5,
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(224, 224, 224, 0.2)'
            }}
            className={'hover'}
          >
            <p style={{ fontWeight: 'bold' }}>
              Lägg till excel med lägenhetsnummer.
            </p>
          </Dropzone>
        )}
        <Paper className={classes.root}>
          <TableTitle
            addIcon={false}
            iconLabel={Strings.default.NEW_USER}
            classes={classes}
            onIconClick={() => {
              this.props.showAlert(
                Strings.default.NEW_USER,
                Strings.default.NEW_USER_INFO,
                Constants.THREE_BUTTONS,
                {
                  title: Strings.default.CANCEL,
                  onPress: () => {}
                },
                {
                  title: Strings.default.CREATE_NEW_USER,
                  onPress: () => this.props.showNewUserModal()
                },
                {
                  title: Strings.default.DOWNLOAD_MANUAL,
                  onPress: () => Functions.getManual(data.community.id)
                }
              )
            }}
            header={Strings.default.MANAGE_APARTMENTS}
            customButtons={[
              {
                label: this.state.downloadingBulkPdf
                  ? Strings.default.DOWNLOADING_MANUALS
                  : Strings.default.DOWNLOAD_ALL_MANUALS,
                icon: faDownload,
                color: this.state.downloadingBulkPdf ? '#999' : '#289e64',
                loading: this.state.downloadingBulkPdf,
                onClick: () => {
                  if (this.state.downloadingBulkPdf) return
                  this.setState({ downloadingBulkPdf: true })
                  API.getBulkApartmentPdf(
                    user.token,
                    data.community.id,
                    comunityName
                  )
                    .then(() => this.setState({ downloadingBulkPdf: false }))
                    .catch(() => {
                      alert(Strings.default.DOWNLOAD_ERROR)
                      this.setState({ downloadingBulkPdf: false })
                    })
                }
              }
            ]}
          />
          <Table className={classes.table} aria-labelledby="tableTitle">
            <TableHead
              rows={APARTMENT_ROWS}
              order={order}
              orderBy={orderBy}
              sortOn={(newOrderBy, newOrder, newSortType) =>
                this.setState({
                  orderBy: newOrderBy,
                  order: newOrder,
                  sortType: newSortType
                })
              }
            />
            {Functions.stableSort(
              apartments,
              Functions.getSorting(order, orderBy, sortType)
            )
              .slice(startIndex, rowsPerPage + startIndex)
              .map((a, i) => {
                const showUsers = showRows.indexOf(a.id) !== -1

                return (
                  <TableBody className={classes.tableBody} key={a.id}>
                    <TableRow className={classes.apartmentRow}>
                      <TableCell className={classes.cell}>
                        <p>{a.address}</p>
                      </TableCell>
                      <TableCell className={classes.cell}>
                        <p>{a.number}</p>
                      </TableCell>
                      <TableCell className={classes.cell}>
                        <p>{a.code}</p>
                      </TableCell>
                      <TableCell className={classes.cell}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end'
                          }}
                        >
                          <IconButton
                            style={{ marginRight: 24 }}
                            aria-label={'Fler alternativ'}
                            onClick={event => {
                              this.setState({
                                anchorEl: event.currentTarget,
                                menuExpanded: a.id
                              })
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faEllipsisV}
                              color={'#3B424D'}
                              style={{ fontSize: 16 }}
                            />
                          </IconButton>
                          <Menu
                            id={'simple-menu'}
                            open={menuExpanded === a.id}
                            anchorEl={anchorEl}
                            onClose={() =>
                              this.setState({ menuExpanded: null })
                            }
                          >
                            <MenuItem
                              onClick={() => {
                                this.setState({ menuExpanded: null })
                                this.props.showNewUserModal(a.id)
                              }}
                            >
                              {Strings.default.ADD_USER_TO_APARTMENT +
                                ' ' +
                                a.number}
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                API.getApartmentPdf(a.code, a.number, comunityName)
                                this.setState({ menuExpanded: null })
                              }}
                            >
                              {Strings.default.DOWNLOAD_MANUAL + ' ' + a.number}
                            </MenuItem>
                          </Menu>
                          {a.users.length === 0 ? (
                            <p style={{ fontWeight: 'bold', color: '#e57373' }}>
                              {Strings.default.NO_USERS}
                            </p>
                          ) : (
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'flex-end'
                              }}
                            >
                              <a
                                style={{ marginRight: 24 }}
                                onClick={() => {
                                  this.props.showAlert(
                                    Strings.default.RESET_APARTMENT,
                                    Strings.default.RESET_APARTMENT_INFO,
                                    Constants.TWO_BUTTONS,
                                    {
                                      title: Strings.default.NO,
                                      onPress: () => {}
                                    },
                                    {
                                      title: Strings.default.YES,
                                      onPress: () =>
                                        this.props.tryResetApartment(
                                          user.token,
                                          data.community.id,
                                          a.id
                                        )
                                    }
                                  )
                                }}
                              >
                                <p style={{ color: '#e57373' }}>
                                  {Strings.default.RESET}
                                </p>
                              </a>
                              <a
                                style={{ marginLeft: 24 }}
                                onClick={() => {
                                  if (showUsers) {
                                    this.setState({
                                      showRows: showRows.filter(
                                        id => id !== a.id
                                      )
                                    })
                                  } else {
                                    this.setState({
                                      showRows: [...showRows, a.id]
                                    })
                                  }
                                }}
                              >
                                <p>
                                  {showUsers
                                    ? Strings.default.HIDE_USERS
                                    : Strings.default.SHOW_USERS}
                                  <FontAwesomeIcon
                                    icon={
                                      showUsers ? faChevronDown : faChevronRight
                                    }
                                    style={{ marginLeft: 15 }}
                                  />
                                </p>
                              </a>
                            </div>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                    {showUsers && a.users.length !== 0 ? (
                      <TableRow className={classes.userRow}>
                        <TableCell className={classes.cell}>
                          <p style={{ fontWeight: 'bold' }}>Email</p>
                        </TableCell>
                        <TableCell className={classes.cell}>
                          <p style={{ fontWeight: 'bold' }}>Administratör</p>
                        </TableCell>
                        <TableCell className={classes.cell} />
                        <TableCell className={classes.cell} />
                      </TableRow>
                    ) : null}
                    {showUsers && a.users.length !== 0
                      ? a.users.map(u => (
                          <TableRow key={u.id} className={classes.userRow}>
                            <TableCell className={classes.cell}>
                              <p>{u.email}</p>
                            </TableCell>
                            <TableCell className={classes.cell}>
                              <p>
                                {u.admin
                                  ? Strings.default.YES
                                  : Strings.default.NO}
                              </p>
                            </TableCell>
                            <TableCell className={classes.cell}></TableCell>
                            <TableCell className={classes.cell}>
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'flex-end'
                                }}
                              >
                                <IconButton
                                  aria-label={'Ändra'}
                                  onClick={() =>
                                    this.props.showEditUserModal(u)
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={faUserEdit}
                                    color={'#3B424D'}
                                    style={{ fontSize: 16 }}
                                  />
                                </IconButton>
                                <IconButton
                                  aria-label={'Ta bort'}
                                  onClick={() => {
                                    this.props.showAlert(
                                      Strings.default.DELETE_USER,
                                      Strings.default.DELETE_USER_INFO,
                                      Constants.TWO_BUTTONS,
                                      {
                                        title: Strings.default.NO,
                                        onPress: () => {}
                                      },
                                      {
                                        title: Strings.default.YES,
                                        onPress: () =>
                                          this.props.tryDeleteUser(
                                            user.token,
                                            data.community.id,
                                            u.id
                                          )
                                      }
                                    )
                                  }}
                                >
                                  <FontAwesomeIcon
                                    icon={faTrash}
                                    color={'#e57373'}
                                    style={{ fontSize: 16 }}
                                  />
                                </IconButton>
                              </div>
                            </TableCell>
                          </TableRow>
                        ))
                      : null}
                  </TableBody>
                )
              })}
          </Table>
          <TablePagination
            component={'div'}
            count={apartments.length}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page'
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page'
            }}
            labelRowsPerPage={'Rader per sida:'}
            labelDisplayedRows={({ from, to, count }) =>
              `${from}-${to} av ${count}`
            }
            onChangePage={(event, page) => this.setState({ page })}
            onChangeRowsPerPage={event =>
              this.setState({ rowsPerPage: event.target.value })
            }
            rowsPerPageOptions={[5, 10, 25, 50, 100]}
          />
        </Paper>
      </div>
    )
  }
}

const Styles = {
  root: {
    width: '100%',
    overflowX: 'auto'
  },
  table: {
    minWidth: 700
  },
  apartmentRow: {
    backgroundColor: '#fff',
    borderBottom: '1px solid rgba(224, 224, 224, 1)'
  },
  userRow: {
    backgroundColor: '#f4f4f8'
  },
  cell: {
    borderBottom: '0px solid transparent'
  },
  spacer: {
    flex: '1 1 100%'
  },
  actions: {
    color: 'green'
  },
  title: {
    flex: '0 0 auto'
  },
  tableBody: {
    borderBottom: '1px solid rgba(224, 224, 224, 1)'
  }
}

UserTable.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps({ data, user }) {
  return { data, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...userActions, ...apartmentsActions },
    dispatch
  )
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(UserTable)



// WEBPACK FOOTER //
// ./src/components/containers/UserTable/index.js